<template>
  <div>
    <Topnav title="DISCUSSION FORUM"></Topnav>
    <Sidebar></Sidebar>
    <div class="content-wrapper" style="background: white">
      <loading
        :active.sync="isLoading"
        :can-cancel="true"
        loader="dots"
        :is-full-page="fullPage"
        :height="height"
        :width="width"
        background-color="#6b6969"
      ></loading>
      <div class="content-header">
        <div class="custom-container-fluid">
          <div class="row">
            <div class="col-md-7 order-md-first order-last">
              <div class="card" @click="$router.push('/dashboard/forum-details')">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12 mb-1">
                      <span class="badge badge-silver">Onboarding</span>
                    </div>
                    <div class="col-12 col-md-9">
                      <h4>How do I get around this platform?</h4>
                    </div>
                    <div class="col-md-3 col-12">
                      <div class="mt-2 text-accent">
                        <i class="material-icons">access_time</i>
                        <span
                          class="mt-1 text-uppercase"
                          style="vertical-align: super"
                        >
                          3 Days ago</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-9 col-7">
                      <div class="mt-2">
                        <img
                          src="@/assets/logo_white.png"
                          style="
                            width: 30px;
                            height: 30px;
                            border-radius: 50%;

                            background: black;
                          "
                          alt=""
                        />
                        <span
                          class="mt-1"
                          style="color: #727272; font-weight: bold"
                          >Ama Berkoh</span
                        >
                      </div>
                    </div>
                    <div class="col-md-3 col-5">
                      <div
                        class="mt-2"
                        style="
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        "
                      >
                        <!-- <i class="fa fa-clock" /> 5 Answers -->

                        <i class="material-icons">insert_comment</i>
                        <span class="mt-1" style="vertical-align: super">
                          5 Answers</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12 mb-1">
                      <span class="badge badge-silver">Onboarding</span>
                    </div>
                    <div class="col-12 col-md-9">
                      <h4>How do I get around this platform?</h4>
                    </div>
                    <div class="col-md-3 col-12">
                      <div class="mt-2 text-accent">
                        <i class="material-icons">access_time</i>
                        <span
                          class="mt-1 text-uppercase"
                          style="vertical-align: super"
                        >
                          3 Days ago</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-9 col-7">
                      <div class="mt-2">
                        <img
                          src="@/assets/logo_white.png"
                          style="
                            width: 30px;
                            height: 30px;
                            border-radius: 50%;

                            background: black;
                          "
                          alt=""
                        />
                        <span
                          class="mt-1"
                          style="color: #727272; font-weight: bold"
                          >Ama Berkoh</span
                        >
                      </div>
                    </div>
                    <div class="col-md-3 col-5">
                      <div
                        class="mt-2"
                        style="
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        "
                      >
                        <i class="material-icons">insert_comment</i>
                        <span class="mt-1" style="vertical-align: super">
                          5 Answers</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
            </div>
            <div class="col-md-3 offset-md-1 order-md-last order-first">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroupPrepend"
                    ><i class="fa fa-search"></i
                  ></span>
                </div>
                <input
                  type="text"
                  class="form-control search-input"
                  placeholder="SEARCH FOR TOPIC"
                  aria-describedby="inputGroupPrepend"
                  required
                />
              </div>
              <div class="card search-card mb-2 bg-ash text-dark">
                <div class="card-body">All</div>
              </div>
              <div class="card search-card mt-3">
                <div class="card-body">Introduction</div>
              </div>
              <div class="card search-card mt-3">
                <div class="card-body">Supervised Learning</div>
              </div>
              <div class="card search-card mt-3">
                <div class="card-body">UnSupervised Learning</div>
              </div>
              <div class="card search-card mt-3">
                <div class="card-body">Reinforcement Learning</div>
              </div>
              <div class="card search-card mt-3">
                <div class="card-body">Classification</div>
              </div>
              <div class="card search-card mt-3">
                <div class="card-body">Reinforcement Learning</div>
              </div>
              <div class="card mt-5" style="border: 1px solid #EE570C;">
                <div class="card-body"><div style="font-weight: bold">Post a query</div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import "vue-loading-overlay/dist/vue-loading.css";
// import '../../../public/plugins/datatables/jquery.dataTables.min.js';
// import 'datatables.net-select';
import Swal from "sweetalert2";

export default {
  name: "Company-Jobs",
  data() {
    return {
      jobs: [],
      isLoading: false,
      fullPage: true,
      height: 128,
      width: 128,
    };
  },
  components: {
    Loading: () => import("vue-loading-overlay"),
    Sidebar: () => import("@/components/Dashboard-sidebar"),
    // foot: () => import('@/components/footer_component'),
    Topnav: () => import("@/components/Dashboard-topnav"),
  },
  methods: {
    getCompanyJobs(initialiseTable) {
      // this.isLoading = true;
      // axios.get(`${process.env.VUE_APP_COMPANY_URL}/getJobByCompanyId/${this.$store.state.userInfo.id}`).then((res) => {
      //     this.jobs = res.data.data;
      //     if (initialiseTable) {
      //         this.$nextTick(() => {
      //             this.loadDatatable();
      //         })
      //     }
      // }).catch((err) => {
      // }).finally(() => {
      //     this.isLoading = false
      // })
    },
    formatdate(date) {
      return date ? moment(date).format("dddd, MMMM D, YYYY") : "";
    },

    loadDatatable() {
      window.$("#example2").DataTable({
        order: [[1, "asc"]],
        paging: false,
        lengthChange: false,
        searching: true,
        ordering: true,
        info: true,
        autoWidth: false,
        responsive: true,
      });
    },
    deleteJob(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          axios
            .delete(`${process.env.VUE_APP_COMPANY_URL}/prod/deleteJob/${id}`, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then((res) => {
              this.getCompanyJobs(false);
              let status = res.data.status;
              if (status) {
                Swal.fire(
                  "Deleted!",
                  "Job has been deleted successfully...",
                  "success"
                );
              }
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      });
    },
  },
  async created() {
    this.$nextTick(() => {
      window.$(".index-page").removeClass("sidebar-open");
    });

    setTimeout(() => {
      window.$(".nav-link").removeClass("active");
      window.$("#forum").addClass("active");
    }, 100);

    this.getCompanyJobs();

    // this.$loadScript("/assets/js/plugins/moment.min.js")
    //     .then(() => {
    //     })
    //     .catch(() => {
    //     });
  },
};
</script>
<style scoped>
.card {
  box-shadow: 0px 0px 4px #c4c4c4;
  border-radius: 10px;
  background: #fefbfb;
}
.badge-silver {
  background-color: #e5e5e5;
  color: #1a0b04;
  text-transform: none !important;
}

.input-group-text {
  border-left: 1px solid #ced4da;
  border-bottom: 1px solid #ced4da;
  border-top: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.search-input {
  border-left: none;
  padding: 24px 24px 24px 0px;
}

.search-card {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
}
</style>


